function showAlert(title, message) {
    const modalAlert = $('#modal-alert');
    if (!modalAlert.length) {
        alert(message);
    } else {
        modalAlert.find('.modal-title').html(title);
        modalAlert.find('.modal-message').html(message);

        modalAlert.modal({
            backdrop: 'static',
            keyboard: false
        });
    }
}

export default showAlert
